import cn from 'classnames';
import Header from '../header/header';
import Footer from '../footer/footer';
import ScrollButton from '../scroll-to-top/scroll-to-top';
import Cookie from '../cookie/cookie';
import styles from './agree-page.module.scss';

function AgreePage() {
	return (
		<div className={styles.wrapper}>
			<Header />
			<main>
				<div className={cn(styles.privacy, 'container')}>
					<h1 className={styles.title}>Согласие на обработку персональных данных </h1>
					<p>Физическое лицо, оставляя заявку на сайте через форму записи, действуя свободно, своей волей и в своем интересе, а также подтверждая свою дееспособность, предоставляет согласие Обществу с ограниченной ответственностью «ДАНТИСТ плюс», ИНН 5036071357, ОГРН 1065074050788, адрес местонахождения 142117, Московская обл., г.Подольск, ул.Кирова, д.61, помещ. 1, адрес электронной почты для обращений субъектов персональных данных dant.plus@yandex.ru, телефон 8 965 197 80 20 (далее — Оператор) на обработку своих персональных данных на следующих условиях:</p>
					<ul className={styles.list}>
						<li>1. Согласие дается на обработку персональных данных как без использования средств автоматизации, так и с их использованием, а также смешанным способом.</li>
						<li>2. Согласие дается на обработку следующих персональных данных, указанных в форме записи на сайте: фамилия, имя, отчество; номер телефона; адрес электронной почты; дата рождения; сведения о выбранной услуге, специалисте, желаемой дате и времени приема; сведения, указанные в комментарии или тексте обращения.</li>
						<li>3. Цели обработки персональных данных: запись на прием; подтверждение, перенос или отмена записи; обратная связь; рассмотрение обращения; подбор специалиста, услуги, даты и времени приема; организация оказания медицинских услуг.</li>
						<li>4. Оператор вправе осуществлять следующие действия с персональными данными: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, предоставление, доступ, блокирование, удаление и уничтожение персональных данных.</li>
						<li>5.	Согласие может быть отозвано путем направления обращения Оператору по адресу: 142117, Московская обл., г.Подольск, ул.Кирова, д.61, помещ. 1, либо по адресу электронной почты: dant.plus@yandex.ru</li>
						<li>6.	Я подтверждаю, что ознакомлен(а) с Политикой конфиденциальности ООО «ДАНТИСТ плюс» в отношении обработки персональных данных, размещенной на сайте. </li>
					</ul>
				</div>
				<ScrollButton />
				<Cookie />
			</main>
			<Footer />
		</div>
	);
}

export default AgreePage;
